'use client';

import SvgChevronRight from '@hc-frontend/core-icons/kit/chevron-right';
import { addClassName } from '@hc-frontend/core-utils-format';
import React, { useRef } from 'react';

import { FormGroup } from '../../templates/form-group/form-group';
import type { SelectProps } from './select.types';

export function Select({
  label,
  icon,
  helpText,
  errorText,
  disabled,
  error,
  name,
  id,
  options,
  className,
  ...selectProps
}: React.ComponentProps<'select'> & SelectProps) {
  const selectRef = useRef<HTMLSelectElement>(null);
  const showErrors = error;
  const selectId = id || name;

  const handleContainerClick = () => {
    selectRef.current?.showPicker?.();
  };

  return (
    <FormGroup disabled={disabled} error={showErrors}>
      <label className="hc-label" htmlFor={selectId}>
        {label}
      </label>
      <div
        role="presentation"
        className="hc-form-control relative"
        onClick={handleContainerClick}
      >
        {icon}
        <select
          {...selectProps}
          ref={selectRef}
          disabled={disabled}
          id={selectId}
          name={name}
          className={addClassName(
            'hc-form-control__select pr-32-32',
            className,
          )}
          aria-invalid={showErrors}
        >
          {options.map(({ id: optionId, label: optionLabel }) => (
            <option value={optionId} key={optionId}>
              {optionLabel}
            </option>
          ))}
        </select>
        <SvgChevronRight className="pointer-events-none absolute right-16-16 top-1/2 -translate-y-1/2 rotate-90 text-primary-900" />
      </div>
      <span className="hc-help-text">{helpText}</span>
      <span className="hc-error-text">{errorText}</span>
    </FormGroup>
  );
}
